import type { Meta, StoryObj } from "@storybook/react";

import type { NotificationSettingsOverviewCardProps } from "@/ui/components/profile";
import { NotificationSettingsOverviewCard } from "@/ui/components/profile";
import { Box } from "@/ui/layout";

const StoryMeta: Meta<NotificationSettingsOverviewCardProps> = {
  title: "Components/Profile/Notification Settings",
  component: NotificationSettingsOverviewCard,
  argTypes: {
    isEmailEnabled: { control: "boolean" },
    isPushEnabled: { control: "boolean" },
    isSmsEnabled: { control: "boolean" },
  },
  args: {
    isEmailEnabled: true,
    isPushEnabled: true,
    isSmsEnabled: false,
  },
  render: (props) => (
    <Box width="100%">
      <NotificationSettingsOverviewCard {...props} />
    </Box>
  ),
};

type Story = StoryObj<NotificationSettingsOverviewCardProps>;

const Primary: Story = {};

export { Primary };
export default StoryMeta;
